module.exports = __webpack_public_path__ + "static/pumpkin-0dc8ed728b0a21c6760993058fcd6308.svg";